/**
 * コレクションを商品DBの「並び順」どおりに表示する
 * =====================================================================
 * なぜ必要か:
 *   Shopifyの「自動コレクション」(ルールで商品を集めるタイプ)は、仕様上
 *   手動並べ替えができない(Admin APIでも不可)。手動コレクションのほうは
 *   商品DBの shopify_reorder.php がShopify側の並び順を直接書き換えているが、
 *   自動コレクションだけはそれができないので、**表示するときにJSで並べ替える**。
 *
 * 並び順の元データ:
 *   商品DB(https://cran777.velvet.jp/products/sort_order_feed.php)が
 *   { "代表コード": 番号 } のJSONを返す。代表コード = Shopifyの商品ハンドル。
 *   番号が小さいほど先頭。番号が無い商品は末尾に回す。
 *
 * どうやって並べ替えるか:
 *   カードのHTMLを自前で組み立てると、価格・セールバッジ・翻訳などを再現しきれず、
 *   テーマを更新したときに崩れる。そこで **Shopifyのセクション描画API**
 *   (`?section_id=...&page=N`)で各ページのグリッドHTMLを取得し、
 *   **テーマが生成した本物のカードを回収して並べ替える**。
 *   14ページの並列取得で0.7秒程度(2026-08-22実測)。
 *
 *   絞り込み中も同じ仕組みで動く(現在のURLのクエリをそのまま引き継ぐため)。
 *
 * 壊れないための方針:
 *   - 途中で失敗したら **何もしない**(サーバーが出した並びのまま)
 *   - ページ送りはテーマ標準のものをそのまま使う(1ページの件数がサーバーと同じなので、
 *     ページ数も一致する)。JSは「そのページに表示すべき48件」に中身を差し替えるだけ
 */
(function () {
  var CONFIG = window.collectionSortOrderConfig || {};
  var FEED_URL = CONFIG.feedUrl;
  var PER_PAGE = parseInt(CONFIG.perPage, 10) || 48;
  var MAX_PAGES = 30; // 暴走よけ(1ページ48件 × 30 = 1,440件まで)

  if (!FEED_URL) return;

  var feedPromise = null;
  var busy = false;

  /**
   * 並べ替えが終わるまでグリッドは透明にしてある(sort-order-pending)。
   * 成功しても失敗しても、最後に必ずこれを呼んで表示に戻す。
   * 通信が固まったときのために、読み込みから5秒たったら問答無用で表示する。
   */
  function reveal() {
    var grid = document.getElementById('product-grid');
    if (grid) grid.classList.remove('sort-order-pending');
  }
  setTimeout(reveal, 5000);

  /** 商品DBから「代表コード → 並び順」を取得(1回だけ) */
  function loadFeed() {
    if (!feedPromise) {
      feedPromise = fetch(FEED_URL)
        .then(function (res) {
          if (!res.ok) throw new Error('feed status ' + res.status);
          return res.json();
        })
        .then(function (data) {
          return data && data.orders ? data.orders : null;
        })
        .catch(function () {
          return null; // 取れなければ並べ替えしない
        });
    }
    return feedPromise;
  }

  /** カードから商品ハンドル(=代表コード)を取り出す */
  function handleOf(item) {
    var link = item.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var href = link.getAttribute('href') || '';
    var part = href.split('/products/')[1];
    if (!part) return null;
    return part.split('?')[0].split('#')[0];
  }

  /** ページャから総ページ数を読む(ページャが無ければ1ページ) */
  function totalPages() {
    var links = document.querySelectorAll('.pagination__list a, .pagination__list span');
    var max = 1;
    for (var i = 0; i < links.length; i++) {
      var n = parseInt((links[i].textContent || '').trim(), 10);
      if (!isNaN(n) && n > max) max = n;
    }
    return Math.min(max, MAX_PAGES);
  }

  /** 指定ページのグリッドHTMLを取得して、カード(li)の配列を返す */
  function fetchPageItems(sectionId, page) {
    var url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(page));
    return fetch(url.toString())
      .then(function (res) {
        if (!res.ok) throw new Error('section status ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return Array.prototype.slice.call(doc.querySelectorAll('#product-grid > li.grid__item'));
      });
  }

  /**
   * スクロール連動アニメーションのクラスを外す。
   * これが付いたままだと、後から差し込んだカードは監視対象にならず
   * 透明のまま表示されない(Dawnの animations.js は読み込み時に監視を始めるため)。
   */
  function stripAnimation(item) {
    item.classList.remove('scroll-trigger', 'animate--slide-in');
    item.removeAttribute('data-cascade');
    item.style.removeProperty('--animation-order');
  }

  function applySortOrder() {
    // 前の処理が走っている最中に絞り込みが更新されると、ここで捨ててしまうと
    // グリッドを透明にしたまま（白いモヤ）戻せなくなる。少し待ってやり直す。
    if (busy) {
      setTimeout(applySortOrder, 300);
      return;
    }
    var grid = document.getElementById('product-grid');
    if (!grid || !grid.dataset.id) { reveal(); return; }
    if (grid.dataset.sortOrderApplied === '1') { reveal(); return; }

    // お客様が「価格の安い順」等を選んでいるときは触らない。
    // (絞り込み・並び替えはページを読み直さずURLだけ書き換わるので、実行のたびに見る)
    var sortBy = new URL(window.location.href).searchParams.get('sort_by');
    if (sortBy && sortBy !== 'manual') { reveal(); return; }

    var sectionId = grid.dataset.id;
    var pages = totalPages();
    var current = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);
    if (isNaN(current) || current < 1) current = 1;

    busy = true;

    loadFeed()
      .then(function (orders) {
        if (!orders) throw new Error('no feed');

        var jobs = [];
        for (var p = 1; p <= pages; p++) jobs.push(fetchPageItems(sectionId, p));

        return Promise.all(jobs).then(function (lists) {
          var items = [];
          lists.forEach(function (list) {
            list.forEach(function (li) { items.push(li); });
          });
          if (!items.length) throw new Error('no items');

          // 並び順の番号で安定ソート(番号なしは末尾。同じ番号なら元の並びを保つ)
          var indexed = items.map(function (li, i) {
            var h = handleOf(li);
            var no = h && Object.prototype.hasOwnProperty.call(orders, h) ? orders[h] : Number.MAX_SAFE_INTEGER;
            return { li: li, no: no, i: i };
          });
          indexed.sort(function (a, b) {
            if (a.no !== b.no) return a.no - b.no;
            return a.i - b.i;
          });

          // このページに出すぶんだけ切り出して差し替える
          var start = (current - 1) * PER_PAGE;
          var slice = indexed.slice(start, start + PER_PAGE);
          if (!slice.length) throw new Error('empty slice');

          var frag = document.createDocumentFragment();
          slice.forEach(function (entry) {
            var li = document.importNode(entry.li, true);
            stripAnimation(li);
            frag.appendChild(li);
          });

          grid.innerHTML = '';
          grid.appendChild(frag);
          grid.dataset.sortOrderApplied = '1';
        });
      })
      .catch(function () {
        // 失敗しても何もしない(サーバーが出した並びのまま表示する)
      })
      .then(function () {
        busy = false;
        reveal();
      });
  }

  /**
   * 絞り込み(facets)を操作するとテーマが #ProductGridContainer の中身を
   * 丸ごと差し替える。そのたびに並べ替えをやり直す。
   */
  function watchFacets() {
    var container = document.getElementById('ProductGridContainer');
    if (!container || !window.MutationObserver) return;
    var timer = null;
    new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(applySortOrder, 50);
    }).observe(container, { childList: true });
  }

  function init() {
    applySortOrder();
    watchFacets();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
